import { PlotTypes } from '@highimpact/dashboard-types';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import {
  getPlotTypePrettyName,
  plotTypes,
} from '../../../../forms/InitiWidgetFormHandler';
import type { MigratedPlotFormProps } from '../../../../forms/formHandlerShared';

import {
  getPlotType,
  setPlotType,
} from '../../../../state/dashboard-element-operations';
import {
  PlotConfigFormDivider,
  PlotConfigFormShell,
  PlotConfigSection,
  PlotConfigSubmitButton,
} from '../../widgets/shared/plotConfigFormLayout';

function UnhandledPlotForm({ config, onChange }: MigratedPlotFormProps) {
  const handlePlotTypeChange = (plotType: PlotTypes) => {
    onChange(setPlotType(plotType, config));
  };

  return (
    <PlotConfigFormShell onSubmit={(event) => event.preventDefault()}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Ce type de graphique n'est pas encore pris en charge
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Veuillez choisir un type de graphique pris en charge pour continuer.
      </Typography>

      <PlotConfigFormDivider />

      <PlotConfigSection title="Type de graphique">
        <FormControl size="small" fullWidth>
          <InputLabel id="unhandled-plot-type-label">
            Type de graphique
          </InputLabel>
          <Select
            labelId="unhandled-plot-type-label"
            value={getPlotType(config)}
            label="Type de graphique"
            onChange={(event) =>
              handlePlotTypeChange(event.target.value as PlotTypes)
            }
          >
            {plotTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {getPlotTypePrettyName(type)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </PlotConfigSection>

      <PlotConfigSubmitButton isSending={false} disabled />
    </PlotConfigFormShell>
  );
}

export default UnhandledPlotForm;
